import { useDispatch, useSelector } from "react-redux";
import { isActionOf } from "typesafe-actions";
import useCurrentStaticList from "../../hooks/useCurrentStaticList";
import { listRenameModalOpenSetAction, updateOpportunityListAsync } from "../../store/action-creators";
import { updateOpportunityListNameThunk } from "../../store/effects";
import { selectOpportunityListRenameModalIsOpen, selectOpportunityListUpdating } from "../../store/selectors";
import ListRenameModalTracked from "./ListRenameModalTrackedContainer";

const ListRenameModalContainer = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector(selectOpportunityListRenameModalIsOpen);
    const isBeingUpdated = useSelector(selectOpportunityListUpdating);
    const list = useCurrentStaticList();

    async function handleRenameSubmit(name: string) {
        if (typeof list === "undefined") {
            return;
        }

        const resultAction = await dispatch(updateOpportunityListNameThunk(name, list.opportunityListId, list.country));
        const isSuccessfulAction = isActionOf(updateOpportunityListAsync.success);

        if (isSuccessfulAction(resultAction)) {
            dispatch(listRenameModalOpenSetAction(false));
        }
    }

    function handleCancel() {
        dispatch(listRenameModalOpenSetAction(false));
    }

    return (
        <ListRenameModalTracked
            isOpen={isOpen}
            isBeingSubmitted={isBeingUpdated}
            currentName={list?.friendlyName ?? ""}
            onCancel={handleCancel}
            onSubmit={handleRenameSubmit}
        />
    );
}

export default ListRenameModalContainer;
